
import React from 'react';
import moment from 'moment-timezone';
import * as utility from 'components/Utils';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more';
import funnel from "highcharts/modules/funnel";
import data from "highcharts/modules/data";
import exporting from "highcharts/modules/exporting";
import exportdata from "highcharts/modules/export-data";


export default class GraphHP extends React.Component {

	constructor(props) {
		super(props);

/*
		var data1 = localStorage.getItem(props.label+"_1");
		var data2 = localStorage.getItem(props.label+"_2");
		var livingroom = localStorage.getItem(props.label+"_3");
		var downstairs = localStorage.getItem(props.label+"_4");
		var dataFurnace = localStorage.getItem("dataFurnace");
*/
		var data1 = [];
		var data2 = [];
		var livingroom = [];
		var downstairs = [];
		var dataFurnace = [];

		let optionsDefault = { credits: { enabled: false }, title: { text: 'fetching data...' } };

		this.state = {
			// interval: 0,
			options: optionsDefault,
			graphType: props.graphType,
			labelHorizontal: props.label,
			width: props.width,
			height: props.height,
			urlData: utility.getRootUrl()+props.urlData,
			data1: data1,
			data2: data2,
			livingroom: livingroom,
			downstairs: downstairs,
			dataFurnace: dataFurnace,
			yMin: 0,
			yMax: 0,
			zoomOffset: props.zoomOffset,
			zoomLevel: props.zoomLevel,
			myTimeZone: -moment().local().utcOffset(),
		};

		this.fetchTheData = this.fetchTheData.bind(this);
		this.getOptions = this.getOptions.bind(this);
	}



	getOptions()
	{
		var data1 = [];
		var data2 = [];
		var livingroom = [];
		var downstairs = [];
		var dataFurnace = [];

		var original_length_data1 = (this.state.data1) ? this.state.data1.length : 0;
		var original_length_data2 = (this.state.data2) ? this.state.data2.length : 0;
		var original_length_livingroom = (this.state.livingroom) ? this.state.livingroom.length : 0;
		var original_length_downstairs = (this.state.downstairs) ? this.state.downstairs.length : 0;
		var original_length_dataFurnace = (this.state.dataFurnace) ? this.state.dataFurnace.length : 0;


		/* zoom the data in/out horizontally */

		let i;
		let startOffset;
		let startDate;
		let d = new Date();
		let now = d.getTime();	/* epoch in seconds */

		let secsToDisplay = this.state.zoomLevel * (24*3600);
		if ( String(this.state.graphType) === "weight" ) {
			secsToDisplay *= 7;
		}
		if ( String(this.state.graphType) === "bp" ) {
			secsToDisplay *= 7;
		}

		startDate = parseInt(now - secsToDisplay);
		startDate -= (24*3600) * this.state.zoomOffset;

		startOffset = parseInt(Math.max(0,(Array.isArray(this.state.data1)) ? this.state.data1.findIndex( (pt) => pt.x > startDate ) : 0));
		for ( i = 0 ; i < original_length_data1 ; i++ ) {
			let pt = this.state.data1[ startOffset + i ];
			if ( !pt || (pt.x > startDate + secsToDisplay) ) {
				break;
			}
			pt.x *= 1000;
			data1[i] = pt;
		}

		startOffset = parseInt(Math.max(0,(Array.isArray(this.state.data2)) ? this.state.data2.findIndex( (pt) => pt.x > startDate ) : 0));
		for ( i = 0 ; i < original_length_data2 ; i++ ) {
			let pt = this.state.data2[ startOffset + i ];
			if ( !pt || (pt.x > startDate + secsToDisplay) ) {
				break;
			}
			pt.x *= 1000;
			data2[i] = pt;
		}

		startOffset = parseInt(Math.max(0,(Array.isArray(this.state.livingroom)) ? this.state.livingroom.findIndex( (pt) => pt.x > startDate ) : 0));
		for ( i = 0 ; i < original_length_livingroom ; i++ ) {
			let pt = this.state.livingroom[ startOffset + i ];
			if ( !pt || (pt.x > startDate + secsToDisplay) ) {
				break;
			}
			pt.x *= 1000;
			livingroom[i] = pt;
		}

		startOffset = parseInt(Math.max(0,(Array.isArray(this.state.downstairs)) ? this.state.downstairs.findIndex( (pt) => pt.x > startDate ) : 0));
		for ( i = 0 ; i < original_length_downstairs ; i++ ) {
			let pt = this.state.downstairs[ startOffset + i ];
			if ( !pt || (pt.x > startDate + secsToDisplay) ) {
				break;
			}
			pt.x *= 1000;
			downstairs[i] = pt;
		}

		startOffset = parseInt(Math.max(0,(Array.isArray(this.state.dataFurnace)) ? this.state.dataFurnace.findIndex( (pt) => pt.x > startDate ) : 0));
		for ( i = 0 ; i < original_length_dataFurnace ; i++ ) {
			let pt = this.state.dataFurnace[ startOffset + i ];
			if ( !pt || (pt.x > startDate + secsToDisplay) ) {
				break;
			}
			pt.x *= 1000;
			dataFurnace[i] = pt;
		}

//		let dataFurnace = [];
//		if ( (String(this.state.graphType) === "temperature") && this.state.dataFurnace ) {
//			let widthBrowser = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
//			var yMin = this.state.yMin;
//			var yMax = this.state.yMax;
//			yMin = this.arrayMin(data1);
//			yMin = Math.min( yMin, this.arrayMin(data2) );
//			yMin = Math.min( yMin, this.arrayMin(livingroom) );
//			yMin = Math.min( yMin, this.arrayMin(downstairs) );
//			yMax = this.arrayMax(data1);
//			yMax = Math.max( yMax, this.arrayMax(data2) );
//			yMax = Math.max( yMax, this.arrayMax(livingroom) );
//			yMax = Math.max( yMax, this.arrayMax(downstairs) );
//			startOffset = parseInt(Math.max(0,(Array.isArray(this.state.dataFurnace)) ? this.state.dataFurnace.findIndex( (pt) => pt.x > startDate ) : 0));
//			for ( i = 0 ; i < original_length_downstairs ; i++ ) {
//				let pt = this.state.dataFurnace[ startOffset + i ];
//				if ( !pt || (pt.x > startDate + secsToDisplay) ) {
//					break;
//				}
//				let xTime = pt.x;
//				xTime += parseInt(7.00 * 60*60);	/* I have no idea why this helps to align the furnace data with the temperatures; probably just timezone... */

//				let pixelsBarWidth = parseInt(Math.max(1,Math.round(widthBrowser * pt.seconds / secsToDisplay)));
//				pixelsBarWidth /= 2;	/* I have not idea why this helps to create the proper sized bar */
//				dataFurnace[i] = { "x": xTime, "y": yMax, "y0": yMin, "barWidth": pixelsBarWidth, "duration": pt.seconds };
//			}
//
//		}


		let theSeries = [
				{
					data: data1,
					lineWidth: 1.0,
					lineColor: "blue",
					name: 'Office'
				},
				{
					data: livingroom,
					lineWidth: 1.0,
					lineColor: "darkviolet",
					name: 'Living Room'
				},
				{
					data: downstairs,
					lineWidth: 1.0,
					lineColor: "darkgreen",
					name: 'Downstairs'
				},
				{
					data: data2,
					lineWidth: 1.0,
					lineColor: "brown",
					name: 'Outside'
				},
			];

		let strTitle = '';
		let strSubTitle = '';
		let strFormat = 'MMM DD';
		if ( String(this.state.graphType) === "temperature" ) {
			// strTitle = 'Temperatures (' + this.state.zoomLevel + ' days)';
			strFormat = 'MMM DD HH:mm';
		} else
		if ( String(this.state.graphType) === "bp" ) {
			// console.log(`secsToDisplay = ${secsToDisplay}   zoomLevel = ${this.state.zoomLevel}`);
			if ( this.state.zoomLevel > 365 ) {
				strFormat = 'MMM YYYY';
			} else {
				strFormat = 'MMM DD HH:mm';
			}
			strSubTitle = this.state.labelHorizontal;
			theSeries = [
					{
						data: data1,
						lineWidth: 1.0,
						lineColor: "blue",
						name: 'Systolic'
					},
					{
						data: data2,
						lineWidth: 1.0,
						lineColor: "brown",
						name: 'Diastolic'
					},
				];
		} else
		if ( String(this.state.graphType) === "weight" ) {
			if ( this.state.zoomLevel > 365 ) {
				strFormat = 'MMM YYYY';
			} else {
				strFormat = 'MMM DD';
			}
			strSubTitle = this.state.labelHorizontal;
			theSeries = [
					{
						data: data1,
						lineWidth: 0.5,
						lineColor: "blue",
						name: 'Weight'
					},
				];
		} else {
		}

		let options = {

			credits: { enabled: false },

			time: {
				timezoneOffset: this.state.myTimeZone
			},

			chart: {
				zoomType: 'x'
			},

			title: {
					text: strTitle
			},

			subtitle: {
					text: strSubTitle
			},

			accessibility: {
					screenReaderSection: {
							beforeChartFormat: '<{headingTagName}>{chartTitle}</{headingTagName}><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div>'
					}
			},

			tooltip: {
				valueDecimals: 1,
				shared: true
			},

			yAxis: {
				title: {
					text: "Lbs"
				}
			},

			xAxis: {
				type: 'datetime',
				// minTickInterval: 6*60*60,
				tickPixelInterval: 50,
				labels: {
					formatter: function() {
						return moment(new Date(this.value)).format(strFormat);
					}
				},
			},

			series: theSeries

		};


		if ( String(this.state.graphType) === "bp" ) {
			options["yAxis"] = {
				title: {
					text: "BP"
				},
				startOnTick: false,
				endOnTick: false,
				tickPixelInterval: 50,
				min: 70,
				max: 190,
				plotBands: [
					{
						from: 0,
						to: 90,
						color: 'rgba( 0, 255, 0, 0.25)',
						label: {
							text: 'Normal',
							style: {
								color: '#606060'
							}
						}
					},
					{
						from: 140,
						to: 300,
						color: 'rgba( 255, 0, 0, 0.1)',
						label: {
							text: 'High',
							style: {
								color: '#606060'
							}
						}
				} ]
			};
		}

		this.setState({ 'options' : options });
	}



	fetchTheData() {

		var temperatureLength = this.state.data1.length;
		var temperatureTimeRecent = moment().subtract(this.state.zoomLevel, 'days').unix();
		if ( this.state.data1 && (this.state.data1.length > 0) && (temperatureLength > 0) && (this.state.data1[0].x <= temperatureTimeRecent) ) {
			temperatureTimeRecent = this.state.data1[temperatureLength - 1].x;
		}

		let separator = (this.state.urlData.includes('?')) ? '&' : '?';
		let url = `${this.state.urlData}${separator}since=${temperatureTimeRecent}`

		console.log(`Fetching data from ${url}` );

		fetch(url)
			.then(response => response.json())
			.then(d => {

					/* ensure all variables are arrays */
					let this_state_data1 = (Array.isArray(this.state.data1)) ? this.state.data1 : [];
					let this_state_data2 = (Array.isArray(this.state.data2)) ? this.state.data2 : [];
					let this_state_livingroom = (Array.isArray(this.state.livingroom)) ? this.state.livingroom : [];
					let this_state_downstairs = (Array.isArray(this.state.downstairs)) ? this.state.downstairs : [];
					d.data1 = (Array.isArray(d.data1)) ? d.data1 : [];
					d.data2 = (Array.isArray(d.data2)) ? d.data2 : [];
					d.livingroom = (Array.isArray(d.livingroom)) ? d.livingroom : [];
					d.downstairs = (Array.isArray(d.downstairs)) ? d.downstairs : [];

					let data1 = [...this_state_data1, ...d.data1];
					let data2 = [...this_state_data2, ...d.data2];
					let livingroom = [...this_state_livingroom, ...d.livingroom];
					let downstairs = [...this_state_downstairs, ...d.downstairs];

					data1.sort((a, b) => a.x - b.x);
					data2.sort((a, b) => a.x - b.x);
					livingroom.sort((a, b) => a.x - b.x);
					downstairs.sort((a, b) => a.x - b.x);

					data1 = [...new Set(data1)];	// remove duplicates
					data2 = [...new Set(data2)];	// remove duplicates
					livingroom = [...new Set(livingroom)];	// remove duplicates
					downstairs = [...new Set(downstairs)];	// remove duplicates

					// throw away extra data from the beginning
					data1 = data1.filter( function(value, index, arr) { return value.x > temperatureTimeRecent; });
					data2 = data2.filter( function(value, index, arr) { return value.x > temperatureTimeRecent; });
					livingroom = livingroom.filter( function(value, index, arr) { return value.x > temperatureTimeRecent; });
					downstairs = downstairs.filter( function(value, index, arr) { return value.x > temperatureTimeRecent; });

					var yMin = this.arrayMin(data1);
					var yMax = this.arrayMax(data1);

					// console.log(`${this.state.graphType} ${this.state.labelHorizontal} length = ${data1 && data1.length} and added length = ${d.data1 && d.data1.length}   d.data:` );

					if ( String(this.state.graphType) === "temperature" ) {
						yMin = Math.min( yMin, this.arrayMin(data2) );
						yMax = Math.max( yMax, this.arrayMax(data2) );
						yMin = Math.min( yMin, this.arrayMin(livingroom) );
						yMax = Math.max( yMax, this.arrayMax(livingroom) );
						yMin = Math.min( yMin, this.arrayMin(downstairs) );
						yMax = Math.max( yMax, this.arrayMax(downstairs) );
					}

					yMin = yMin - 1;
					yMax = yMax + 1;

					this.setState({ data1: data1, data2: data2, livingroom: livingroom, downstairs: downstairs });
					this.setState({ yMin: yMin, yMax: yMax });

					this.getOptions();
				} );
	}


	componentDidMount()
	{
		this.fetchTheData();
		this.interval = setInterval(() => this.fetchTheData(), 3600*1000);	// every hour refresh the graphs
	}


	arrayMin(arr) {
		if ( ! arr ) {
			return 0;
		}
		let len = arr.length;
		let min = Infinity;
		while (len--) {
			if (arr[len].y < min) {
				min = arr[len].y;
			}
		}
		return min;
	};

	arrayMax(arr) {
		if ( ! arr ) {
			return Infinity;
		}
		let len = arr.length;
		let max = -Infinity;
		while (len--) {
			if (arr[len].y > max) {
				max = arr[len].y;
			}
		}
		return max;
	};

	arrayAverage(objXY, n) {
		var result = [];
		if ( objXY == null ) {
			return result;
		}
		for ( var i = 0; i < objXY.length; i += n ) {
			var sumX = 0;
			var sumY = 0;
			for ( var j = 0; j < n ; j++ ) {
				if ( i + j >= objXY.length ) {
					sumX += objXY[objXY.length - 1].x;
					sumY += objXY[objXY.length - 1].y;
				} else {
					sumX += objXY[i+j].x;
					sumY += objXY[i+j].y;
				}
			}
			var avgY = parseInt((sumY/n + 0.5) * 10) / 10;
			result.push( { "x" : sumX/n, "y": avgY } );
		}
		return result
	}





	render() {

		highchartsMore(Highcharts);
		data(Highcharts);
		exporting(Highcharts);
		exportdata(Highcharts);
		funnel(Highcharts);

        return (
			<>
			<div height="300">
				<HighchartsReact highcharts={Highcharts} options={this.state.options} />
			</div>
			</>
		);
	}
}

